module.exports = __webpack_public_path__ + "img/fondo-banner-principal.5def95ac.png";